import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { verifyScreenVerbiage } from "../constants/verify-success";
import "../resources/styles/components/verify-success.scss";
import utils from "../util/utils";

interface Props extends RouteComponentProps<any>{}
type State = {
    verifiedMsg: string,
};

/**
 * Component to display successful 2FA verification
 */
export default class VerifySuccess extends React.Component<Props, State>{
	constructor(props:Props) {
		super(props);

		this.state = {
            verifiedMsg: "",
		}
	}

    componentDidMount = () => {
        const routeProps = this.props.location.state as any;

        this.setState({
            verifiedMsg: routeProps.hasPhoneNumbers 
                ? verifyScreenVerbiage.RECOMMEND_2FA_ALWAYS_ON 
                : verifyScreenVerbiage.NO_PHONE_NUM_VERIFIED,
        })

        //set logo to use login process instead of going to login screen
        window.parent.document.getElementById('employer-site-logo')?.setAttribute('href', utils.getHomePageUrl());
    }

    updateWindowLocation = (url: string) => {
        window.parent.location.href = url;
    }

	render() {
		return (
            <div className="text-centered">
                <span className="icon-verified-check verified-check-icon" />
                <h1 className="verified-header">
                    You're Verified!
                </h1>
                <div className="mb-40 verified-message">
                    {this.state.verifiedMsg}
                </div>
                <div className="mb-30">
                    <button className="mp-btn mp-btn-secondary mp-btn-small verify-button"
                        onClick={() => { this.updateWindowLocation(utils.getHomePageUrl() + verifyScreenVerbiage.UPDATE_PHONE_LINK_PARAM) }} >
                        {verifyScreenVerbiage.UPDATE_PHONE_CONTACT_INFO}
                    </button>
                </div>
                <div className="mb-30">
                    <button className="mp-btn mp-btn-secondary mp-btn-small verify-button" 
                        onClick={() => { this.updateWindowLocation(utils.getHomePageUrl() + verifyScreenVerbiage.UPDATE_EMAIL_LINK_PARAM) }} >
                        {verifyScreenVerbiage.UPDATE_EMAIL_CONTACT_INFO}
                    </button>
                </div>
                <div className="mb-40">
                    <a className="mp-btn mp-btn-outline-primary no-outline" target="_top" href={utils.getHomePageUrl()}>{verifyScreenVerbiage.UPDATE_LATER}</a>
                </div>
            </div>
		);
	}
}